"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var assign_1 = require("./assign");
var deriveCustomTypeInstance_1 = require("./deriveCustomTypeInstance");
/**
 * Patches an immutable object by shallow cloning it (if not already patched),
 * and replacing the previous reference in the tree with the mutable patched
 * version.
 *
 * Marks it as patched in the `patches` tree by adding a node at the same
 * key.
 */
var applyPatchAtPath = function (value, key, patches, isClientSide) {
    // If the value at this path has already been patched and is
    // in a draft state, abort.
    if (isClientSide === void 0) { isClientSide = typeof window !== 'undefined'; }
    if (patches[key])
        return;
    patches[key] = {
        patches: {}
    };
    var source = value[key];
    if (typeof source !== 'object' || (isClientSide && source instanceof Node))
        return;
    var descriptor = Object.getOwnPropertyDescriptor(value, key);
    if (source !== null && descriptor && !descriptor.get) {
        value[key] = Array.isArray(source)
            ? source.slice(0)
            : assign_1.default(deriveCustomTypeInstance_1.default(source), source);
    }
};
exports.default = applyPatchAtPath;
//# sourceMappingURL=applyPatchAtPath.js.map